export default "assets/images/wine-shadow-2bf0e586.png";